import moment from "moment";

export const FORECAST_NEW_PRODUCT_DATE_RANGES = {
    "1_MONTH": {
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().add(1, "month").format("YYYY-MM-DD"),
    },
    "2_MONTHS": {
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().add(2, "month").format("YYYY-MM-DD"),
    },
    "3_MONTHS": {
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().add(3, "month").format("YYYY-MM-DD"),
    },
    "4_MONTHS": {
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().add(4, "month").format("YYYY-MM-DD"),
    },
    "5_MONTHS": {
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().add(5, "month").format("YYYY-MM-DD"),
    },
    "6_MONTHS": {
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().add(6, "month").format("YYYY-MM-DD"),
    },
};
